import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FaFacebookF, FaWhatsapp } from 'react-icons/fa';
import { FiInstagram } from 'react-icons/fi';
import { AiOutlineLinkedin } from 'react-icons/ai';
import { MdOutlineEmail } from 'react-icons/md';

const Footer = () => {
  return (
    <footer className="ft">
      {/* Decorative SVG wave separator */}
      <div className="ft__wave">
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none" fill="none">
          <path d="M0 30C240 50 480 10 720 30C960 50 1200 10 1440 30V60H0V30Z" fill="#0C0614" />
        </svg>
      </div>

      <div className="ft__body">
        {/* Floating decorative nodes */}
        <svg className="ft__deco" viewBox="0 0 1440 400" preserveAspectRatio="xMidYMid slice">
          <circle cx="120" cy="80" r="60" fill="none" stroke="rgba(107,63,163,0.08)" strokeWidth="1" />
          <circle cx="1320" cy="120" r="80" fill="none" stroke="rgba(26,138,99,0.06)" strokeWidth="1" />
          <circle cx="700" cy="350" r="45" fill="none" stroke="rgba(107,63,163,0.05)" strokeWidth="1" />
          <line x1="180" y1="80" x2="655" y2="350" stroke="rgba(107,63,163,0.04)" strokeWidth="0.5" />
          <line x1="745" y1="350" x2="1240" y2="120" stroke="rgba(26,138,99,0.03)" strokeWidth="0.5" />
        </svg>

        <div className="ft__inner">
          {/* Top row — Brand + Newsletter */}
          <div className="ft__top">
            <div className="ft__brand">
              <div className="ft__logo">SOMFIN</div>
              <p className="ft__tagline">Building financial clarity for individuals and businesses across India.</p>
              <div className="ft__socials">
                <a href="https://www.facebook.com/people/SomFin/61556038953638/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
                <a href="https://www.instagram.com/somfinofficial/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FiInstagram /></a>
                <a href="https://www.linkedin.com/company/somfin/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><AiOutlineLinkedin /></a>
                <a href="https://api.whatsapp.com/send?phone=918583011212" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
              </div>
            </div>

            <div className="ft__links-group">
              <div className="ft__col">
                <div className="ft__col-title">Platform</div>
                <Link to="/individual" className="ft__link">Individual</Link>
                <Link to="/business" className="ft__link">Business</Link>
                <Link to="/finlit" className="ft__link">Financial Literacy</Link>
                <Link to="/explore" className="ft__link">Explore</Link>
              </div>

              <div className="ft__col">
                <div className="ft__col-title">Company</div>
                <Link to="/aboutus" className="ft__link">About Us</Link>
                <Link to="/contact" className="ft__link">Contact</Link>
                <Link to="/term" className="ft__link">Terms & Conditions</Link>
                <Link to="/privacy" className="ft__link">Privacy Policy</Link>
              </div>

              <div className="ft__col">
                <div className="ft__col-title">Reach Us</div>
                <a href="mailto:admin@thesomfin.com" className="ft__link ft__link--contact">
                  <MdOutlineEmail size={14} /> admin@thesomfin.com
                </a>
                <a href="mailto:omprakash@thesomfin.com" className="ft__link ft__link--contact">
                  <MdOutlineEmail size={14} /> omprakash@thesomfin.com
                </a>
                <a href="mailto:souryadeepta@thesomfin.com" className="ft__link ft__link--contact">
                  <MdOutlineEmail size={14} /> souryadeepta@thesomfin.com
                </a>
                <a href="https://api.whatsapp.com/send?phone=918583011212" className="ft__link ft__link--contact" target="_blank" rel="noopener noreferrer">
                  <FaWhatsapp size={14} /> +91 (858) 301 1212
                </a>
              </div>
            </div>
          </div>

          {/* Address bar */}
          <div className="ft__address-bar">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ft__address-icon">
              <path d="M21 10c0 6-9 13-9 13S3 16 3 10a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" />
            </svg>
            <span>IITM Research Park, 1FA I Floor, Kanagam Road, TTTI Taramani, Chennai, Tamil Nadu — 600113</span>
          </div>

          {/* Bottom bar */}
          <div className="ft__bottom">
            <div className="ft__badges">
              <span className="ft__badge">AES-256 Encrypted</span>
              <span className="ft__badge">IITM Research Park</span>
              <span className="ft__badge">Made in India</span>
            </div>
            <div className="ft__copyright">
              &copy; {new Date().getFullYear()} SOMFIN. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;